/**
 * GlobalSchema — mounts Organization, LocalBusiness and WebSite JSON-LD
 * on every route. Rendered once from App.js so category and page-level
 * BreadcrumbList / Product / FAQPage schemas can reference it via @id.
 */

import {
  organizationSchema,
  localBusinessSchema,
  websiteSchema,
} from "@/lib/seo/schemas";
import { safeJsonLd } from "@/lib/seo/safeJson";

const payloads = [organizationSchema(), localBusinessSchema(), websiteSchema()];

export const GlobalSchema = () => (
  <>
    {payloads.map((obj) => (
      <script
        key={obj["@type"] || obj["@id"] || JSON.stringify(obj).slice(0, 64)}
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: safeJsonLd(obj) }}
      />
    ))}
  </>
);

export default GlobalSchema;
